export const CHANNEL_LATEST_URL =
  "https://github.com/m8t-labs/m8t/releases/latest/download/manifest.json";

/**
 * Normalize ANY platform version form — bare (`0.2.0`), v-prefixed (`v0.2.0`),
 * or a full tag (`platform-v0.2.0`) — to the canonical release TAG
 * (`platform-v0.2.0`). This is the ONE place the tag/bare distinction is
 * resolved: every per-version release URL must route through it, so a caller
 * that only has a bare version (e.g. the rollback path's
 * `previousPlatformVersion`) can never hand-build a `…/download/0.2.0/…` URL
 * that 404s against the tag-keyed release asset.
 */
export function platformTag(version: string): string {
  const bare = version.trim().replace(/^platform-/, "").replace(/^v/, "");
  return `platform-v${bare}`;
}

export function channelUrlForVersion(version: string): string {
  return `https://github.com/m8t-labs/m8t/releases/download/${platformTag(version)}/manifest.json`;
}

/**
 * A file attached to a release, addressed by the release's own tag. Components
 * released on their own cadence — the companions are the first — carry their
 * tag in the manifest that pins them, rather than deriving it from the
 * platform's.
 */
export function releaseAssetUrl(tag: string, asset: string): string {
  return `https://github.com/m8t-labs/m8t/releases/download/${tag}/${asset}`;
}
